
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "@lingui/react", version: "6.0.0", factory: function() { return Promise.all([__webpack_require__.e("-webpack_sharing_consume_default_react_react-_95a5"), __webpack_require__.e("-webpack_sharing_consume_default_react_react-_d135"), __webpack_require__.e("node_modules_bun_lingui_react_6_0_0_e84808fa12a440cc_node_modules_lingui_react_dist_index_mjs-_a1101")]).then(function() { return function() { return __webpack_require__("../../node_modules/.bun/@lingui+react@6.0.0+e84808fa12a440cc/node_modules/@lingui/react/dist/index.mjs"); }; }); }, eager: 0, treeShakingMode: null }, { name: "@tanstack/react-query", version: "5.28.6", factory: function() { return Promise.all([__webpack_require__.e("vendors-node_modules_bun_tanstack_react-query_5_28_6_5e44392892a7cd3e_node_modules_tanstack_r-1a69d0"), __webpack_require__.e("-webpack_sharing_consume_default_react_react-_95a5"), __webpack_require__.e("-webpack_sharing_consume_default_react_react-_b06c"), __webpack_require__.e("node_modules_bun_react_18_2_0_node_modules_react_jsx-runtime_js")]).then(function() { return function() { return __webpack_require__("../../node_modules/.bun/@tanstack+react-query@5.28.6+5e44392892a7cd3e/node_modules/@tanstack/react-query/build/modern/index.js"); }; }); }, eager: 0, treeShakingMode: null }, { name: "react-dom", version: "18.2.0", factory: function() { return Promise.all([__webpack_require__.e("vendors-node_modules_bun_react-dom_18_2_0_5e44392892a7cd3e_node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react-_bbd3")]).then(function() { return function() { return __webpack_require__("../../node_modules/.bun/react-dom@18.2.0+5e44392892a7cd3e/node_modules/react-dom/index.js"); }; }); }, eager: 0, treeShakingMode: null }, { name: "react-router-dom", version: "5.3.0", factory: function() { return Promise.all([__webpack_require__.e("vendors-node_modules_bun_react-router-dom_5_3_0_5e44392892a7cd3e_node_modules_react-router-do-1f2ff4"), __webpack_require__.e("webpack_sharing_consume_default_react_react-webpack_sharing_consume_default_react_react")]).then(function() { return function() { return __webpack_require__("../../node_modules/.bun/react-router-dom@5.3.0+5e44392892a7cd3e/node_modules/react-router-dom/esm/react-router-dom.js"); }; }); }, eager: 0, treeShakingMode: null }, { name: "react", version: "18.2.0", factory: function() { return __webpack_require__.e("node_modules_bun_react_18_2_0_node_modules_react_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.bun/react@18.2.0/node_modules/react/index.js"); }; }); }, eager: 0, treeShakingMode: null }, "webpack/container/reference/base", "webpack/container/reference/widgets", "webpack/container/reference/kfcomponents", "webpack/container/reference/kfplatform"] }, uniqueName: "account-web" };
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if (!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if (!initToken) initToken = initTokens[name] = {};
	if (initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if (initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if (!__webpack_require__.o(__webpack_require__.S, name))
		__webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function (msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = __webpack_require__.initializeSharingData.uniqueName;
	var register = function (name, version, factory, eager) {
		var versions = (scope[name] = scope[name] || {});
		var activeVersion = versions[version];
		if (
			!activeVersion ||
			(!activeVersion.loaded &&
				(!eager != !activeVersion.eager
					? eager
					: uniqueName > activeVersion.from))
		)
			versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function (id) {
		var handleError = function (err) {
			warn("Initialization of sharing external failed: " + err);
		};
		try {
			var module = __webpack_require__(id);
			if (!module) return;
			var initFn = function (module) {
				return (
					module &&
					module.init &&
					module.init(__webpack_require__.S[name], initScope)
				);
			};
			if (module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if (initResult && initResult.then)
				return promises.push(initResult["catch"](handleError));
		} catch (err) {
			handleError(err);
		}
	};
	var promises = [];
	var scopeToSharingDataMapping = __webpack_require__.initializeSharingData.scopeToSharingDataMapping;
	if (scopeToSharingDataMapping[name]) {
		scopeToSharingDataMapping[name].forEach(function (stage) {
			if (typeof stage === "object") register(stage.name, stage.version, stage.factory, stage.eager);
			else initExternal(stage)
		});
	}
	if (!promises.length) return (initPromises[name] = 1);
	return (initPromises[name] = Promise.all(promises).then(function () {
		return (initPromises[name] = 1);
	}));
};

